import { createReducer } from './Utils';
import { AdminBoardsSummaryState, AdminOrgsState, AdminOrgState, AdminSummaryState, FunctionMap } from '../../types';
import {
  AdminModifyBoardOnOrg,
  AdminModifyBoardOnOrgOpt,
  AdminModifyCompetitionOnOrg,
  AdminModifyCompetitionOnOrgOpt,
  FSAInterface,
  SetAdminBoardsSummary,
  SetAdminOrgPage,
  SetAdminOrgsList,
  SetAdminSummary,
} from '../actions';
import {
  ADMIN_BOARD_META_MODIFY_REQUEST,
  ADMIN_BOARD_META_MODIFY_SUCCESS,
  ADMIN_COMPETITION_META_MODIFY_REQUEST,
  ADMIN_COMPETITION_META_MODIFY_SUCCESS,
  ADMIN_ORG_GET_BOARDS_SUMMARY_SUCCESS,
  ADMIN_ORG_MODIFY_SUCCESS,
  ADMIN_ORG_PAGE_SUCCESS,
  ADMIN_ORGS_LIST_SUCCESS,
  ADMIN_SYSTEM_SUMMARY_SUCCESS,
  ADMIN_ADD_KEYWORD_SUCCESS,
} from '../constants';
import { AdminKeyword } from '../../models/Admin';

function setSystemSummary(state: AdminSummaryState, action: FSAInterface<SetAdminSummary['payload']>) {
  return { ...state, summary: { ...action.payload } };
}

function setOrg(state: AdminOrgState, action: FSAInterface<SetAdminOrgPage['payload']>) {
  return { ...state, org: { ...action.payload } };
}

function updateOrg(state: AdminOrgState, action: FSAInterface<SetAdminOrgPage['payload']>) {
  const { org } = { ...state };
  return { ...state, org: { ...org, ...action.payload } };
}

function setOrgList(state: AdminOrgsState, action: FSAInterface<SetAdminOrgsList['payload']>) {
  return { ...state, orgs: { list: [...(action.payload?.orgs ?? [])], total: action.payload?.total } };
}

function updateBoardOnOrg(state: AdminOrgState, action: FSAInterface<AdminModifyBoardOnOrg['payload']>) {
  const tempOrg = { ...state.org, boards: [...state.org.boards] };
  const indexToUpdate = tempOrg.boards.findIndex((board) => board._id === action.payload?.data._id);
  const currentBoardState = tempOrg.boards[indexToUpdate];
  tempOrg.boards[indexToUpdate] = { ...currentBoardState, ...action.payload?.data.metadata };
  return { ...state, org: { ...tempOrg } };
}

function updateBoardOnOrgOpt(state: AdminOrgState, action: FSAInterface<AdminModifyBoardOnOrgOpt['payload']>) {
  const tempOrg = { ...state.org, boards: [...state.org.boards] };
  const indexToUpdate = tempOrg.boards.findIndex((board) => board._id === action.payload?._id);
  const currentBoardState = tempOrg.boards[indexToUpdate];
  tempOrg.boards[indexToUpdate] = { ...currentBoardState, ...action.payload?.metadata };
  return { ...state, org: { ...tempOrg } };
}

function updateCompetitionOnOrg(state: AdminOrgState, action: FSAInterface<AdminModifyCompetitionOnOrg['payload']>) {
  const tempOrg = { ...state.org, competitions: [...state.org.competitions] };
  const indexToUpdate = tempOrg.competitions.findIndex((competition) => competition._id === action.payload?.data._id);
  const currentCompetitionState = tempOrg.competitions[indexToUpdate];
  tempOrg.competitions[indexToUpdate] = {
    ...currentCompetitionState,
    metadata: { ...currentCompetitionState.metadata, ...action.payload?.data.metadata },
  };
  return { ...state, org: { ...tempOrg } };
}

function updateCompetitionOnOrgOpt(state: AdminOrgState, action: FSAInterface<AdminModifyCompetitionOnOrgOpt['payload']>) {
  const tempOrg = { ...state.org, competitions: [...state.org.competitions] };
  const indexToUpdate = tempOrg.competitions.findIndex((competition) => competition._id === action.payload?._id);
  const currentCompetitionState = tempOrg.competitions[indexToUpdate];
  tempOrg.competitions[indexToUpdate] = {
    ...currentCompetitionState,
    metadata: { ...currentCompetitionState.metadata, ...action.payload?.metadata },
  };
  return { ...state, org: { ...tempOrg } };
}

function setBoardsSummary(state: AdminBoardsSummaryState, action: FSAInterface<SetAdminBoardsSummary['payload']>) {
  return { ...state, boardSummary: { ...action.payload } };
}

function updateBoardKeywords(state: AdminOrgState, action: FSAInterface<AdminKeyword>) {
  const tempOrg = { ...state.org, boards: [...state.org.boards] };
  const indexToUpdate = tempOrg.boards.findIndex((board) => board._id === action?.payload?.boardId);
  const currentBoardState = tempOrg.boards[indexToUpdate];
  tempOrg.boards[indexToUpdate] = {
    ...currentBoardState,
    keywords: [...currentBoardState.keywords, action.payload as AdminKeyword],
  };
  return { ...state, org: { ...tempOrg } };
}

const functionMap: FunctionMap = {
  [ADMIN_SYSTEM_SUMMARY_SUCCESS]: setSystemSummary,
  [ADMIN_ORG_PAGE_SUCCESS]: setOrg,
  [ADMIN_ORG_MODIFY_SUCCESS]: updateOrg,
  [ADMIN_ORGS_LIST_SUCCESS]: setOrgList,
  [ADMIN_BOARD_META_MODIFY_REQUEST]: updateBoardOnOrgOpt,
  [ADMIN_BOARD_META_MODIFY_SUCCESS]: updateBoardOnOrg,
  [ADMIN_ORG_GET_BOARDS_SUMMARY_SUCCESS]: setBoardsSummary,
  [ADMIN_COMPETITION_META_MODIFY_REQUEST]: updateCompetitionOnOrgOpt,
  [ADMIN_COMPETITION_META_MODIFY_SUCCESS]: updateCompetitionOnOrg,
  [ADMIN_ADD_KEYWORD_SUCCESS]: updateBoardKeywords,
};

export default createReducer(functionMap, {});
